<template>
  <PermissionSingle
    v-if="permissionLoaded"
    :permission="permission"
  />
</template>

<script>
import PermissionSingle from '../../components/PermissionSingle'

export default {
  name: 'PermissionSinglePage',

  components: {
    PermissionSingle
  },

  async beforeRouteLeave (to, from, next) {
    if (this.permission && this.permission.isChanged) {
      const answer = await this.$root.$confirm(this.$t('Attention'), this.$t('You have unsaved changes. Are you sure want to leave?'), { color: 'primary' })
      if (answer) {
        this.permission.reset()
      }
      return next(answer)
    }
    next()
  },

  actionBar () {
    return {
      title: 'Permission',
      actions: [
        {
          text: 'Back',
          event: 'back',
          disabled: false
        },
        {
          text: 'Save',
          event: 'save',
          disabled: true
        },
        {
          color: 'error',
          text: 'Delete',
          event: 'delete',
          disabled: true
        }
      ]
    }
  },

  data () {
    return {
      permission: {},
      permissionLoaded: false
    }
  },

  computed: {
    isCreate () {
      return this.$route.params.id === '__'
    },

    saveActionStates () {
      return {
        disabled: !this.permission || this.permission.inProgress || !this.permission.isChanged || this.permission.errors.length,
        loading: !this.permission || this.permission.inProgress
      }
    },

    deleteActionStates () {
      return {
        disabled: !this.permission || this.permission.inProgress || this.isCreate
      }
    }
  },

  async mounted () {
    try {
      if (this.isCreate) {
        this.permission = this.$http.make('auth:permission')
      } else {
        this.permission = await this.$http.make('auth:permission').find(this.$route.params.id)
      }
      this.permissionLoaded = true
      this.permission.reset()

      if (this.isCreate) {
        this.$radio.$emit('action-panel-title', 'New Permission')
      } else {
        this.$radio.$emit('action-panel-title', this.permission.name)
      }
    } catch (e) {
      this.$toast.error(this.$t(e.message))
    }
  },

  methods: {
    goBack () {
      this.$router.push({ name: 'permissions' })
    },

    onActionBack () {
      this.goBack()
    },

    async onActionSave () {
      try {
        await this.permission.save()

        if (this.isCreate) {
          this.$router.replace({
            name: 'single_permission',
            params: { id: this.permission.id }
          })

          this.$toast.success(this.$t('Permission created'))
          return
        }
        this.$toast.success(this.$t('Permission updated'))
      } catch (e) {
        this.$toast.error(this.$t(e.message))
      }
    },

    async onActionDelete () {
      if (!await this.$root.$confirm(this.$t('Delete Permission'), this.$t('Please Confirm'), { color: 'red' })) {
        return
      }
      await this.permission.delete()
      this.goBack()
    }
  }
}
</script>
